.value {
  word-break: break-word;
}
